import { PERMANENCE } from '@/constants/constants';

export const normalizeContracts = (response) => {
  let contractsNormalized = null;
  const listPermanences = [];
  if (response) {
    contractsNormalized = response;
    const { productos } = contractsNormalized;
    productos.forEach((product) => {
      const { acuerdos } = product;
      acuerdos.forEach((acuerdo) => {
        const { terms } = acuerdo;
        terms.forEach((term) => {
          if (term.tipoTermino === PERMANENCE) {
            const newTerm = term;
            newTerm.title = product.descripcion;
            listPermanences.push(newTerm);
          }
        });
      });
    });
  }
  contractsNormalized.listPermanences = listPermanences;
  return contractsNormalized;
};

export const normalizeContractsById = (response, productId) => {
  const contractsNormalized = {};
  if (response) {
    const { productos } = response;
    if (productos && Array.isArray(productos) && productos.length > 0) {
      const [product] = productos;
      const { id, descripcion, acuerdos } = product;
      if (id === productId) {
        contractsNormalized.description = descripcion;
        contractsNormalized.contracts = acuerdos;
      }
    }
  }
  return { id: productId, data: contractsNormalized };
};
